
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 14.5c0 .825-.675 1.5-1.5 1.5h-3c-.825 0-1.5-.675-1.5-1.5v-3c0-.825.675-1.5 1.5-1.5h3c.825 0 1.5.675 1.5 1.5v3zM22 14.5c0 .825-.675 1.5-1.5 1.5h-3c-.825 0-1.5-.675-1.5-1.5v-3c0-.825.675-1.5 1.5-1.5h3c.825 0 1.5.675 1.5 1.5v3zM12 24.5c0 .825-.675 1.5-1.5 1.5h-3c-.825 0-1.5-.675-1.5-1.5v-3c0-.825.675-1.5 1.5-1.5h3c.825 0 1.5.675 1.5 1.5v3zM22 24.5c0 .825-.675 1.5-1.5 1.5h-3c-.825 0-1.5-.675-1.5-1.5v-3c0-.825.675-1.5 1.5-1.5h3c.825 0 1.5.675 1.5 1.5v3zM28.503 5L32 1.503V0h-1.503L27 3.497 23.503 0H22v1.503L25.497 5 22 8.497V10h1.503L27 6.503 30.497 10H32V8.497zM0 24h2v4H0v-4zM0 18h2v4H0v-4zM26 14h2v4h-2v-4zM26 26h2v4h-2v-4zM26 20h2v4h-2v-4zM0 12h2v4H0v-4zM0 6h2v4H0V6zM16 4h4v2h-4V4zM10 4h4v2h-4V4zM4 4h4v2H4V4zM14 30h4v2h-4v-2zM20 30h4v2h-4v-2zM8 30h4v2H8v-2zM2 30h4v2H2v-2z"}})])
          )
        }
      }
    